import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { UtilitiesService } from '@services/utilities.service';
import { IDetailProduct, IListHistoryDistributorExclusive } from '../../../Products.interface';
import { API } from '@config/constants/api.constant';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from '@services/base-service.service';
import { IQueryParams } from '@shared/interface/urlparam.interface';
import { SwiperComponent } from 'swiper/angular';
import { TableColumn } from '@shared/interface/table.interface';
import { IModalDetailWithImage, ModalConfig, ModalOption } from '@shared/components/modal/modal.interface';
import { BaseDatasource } from '@shared/base/base.datasource';
import { BehaviorSubject, Subscription } from 'rxjs';
import { IKeyValue } from '@pages/distributor/interfaces/distributor.interface';
import { UrlUtilsService } from '@utils/url-utils.service';
import { BaseTableService } from '@shared/base/base-table-service.service';
import { PageInfoService, PageLink } from '@metronic/layout';
import { RolePrivilegeService } from '@services/role-privilege.service';
import { ModalDetailWithImageComponent } from '@shared/components/modal/modal-detail-with-image/modal-detail-with-image.component';
import { FilterService } from '@services/filter.service';

@Component({
  selector: 'app-distributor-exclusive-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss'],
})
export class HistoryComponent implements OnInit, OnDestroy {
  @ViewChild('swiperVariant', { static: false }) swiperVariant: SwiperComponent;
  tableColumns: TableColumn[];
  modalDetailConfig: ModalConfig;
  modalDetailOption: ModalOption;
  displayedColumns: string[];
  links: Array<PageLink>;
  string_filter: string = '';
  distributorExclusiveList: IListHistoryDistributorExclusive[];
  detailProduct: BehaviorSubject<IDetailProduct | undefined> = new BehaviorSubject<IDetailProduct | undefined>(undefined);
  baseDatasourceDistributorExclusive: BaseDatasource<IListHistoryDistributorExclusive>;
  detailDistributorExclusiveData: BehaviorSubject<IModalDetailWithImage> = new BehaviorSubject<IModalDetailWithImage>({} as IModalDetailWithImage);
  BrandId: BehaviorSubject<string> = new BehaviorSubject<string>('');
  urlPreview: BehaviorSubject<string> = new BehaviorSubject<string>('');
  isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  iconNone: string = STRING_CONSTANTS.ILLUSTRATIONS.IL_BOX_NONE;
  iconInfo: string = STRING_CONSTANTS.ICON.IC_INFO;
  iconAction: string = STRING_CONSTANTS.ICON.IC_ACTIONS_TABLE;
  STRING_CONSTANTS = STRING_CONSTANTS;
  productId: string;
  parentMenu: string = 'PRODUCT_CATALOG';
  privilegeEditProduct: boolean = false;
  privilegeUnpublishedProduct: boolean = false;
  keyDetailPrivilege: string = 'DETAIL_PRODUCT';
  keyProductPrivilege: string = 'LIST_PRODUCT_PUBLISHED';
  @ViewChild('modalDetail') private modalDetail: ModalDetailWithImageComponent;
  private unsubscribe: Subscription[] = [];

  constructor(
    private pageInfoService: PageInfoService,
    private activeRoute: ActivatedRoute,
    private urlParamService: UrlUtilsService,
    private baseService: BaseService,
    private baseTableService: BaseTableService<any>,
    private ref: ChangeDetectorRef,
    private router: Router,
    public utilities: UtilitiesService,
    private rolePrivilegeService: RolePrivilegeService,
    private filterService: FilterService
  ) {}

  ngOnInit(): void {
    this.baseTableService.responseDatabase.subscribe((response) => (this.baseDatasourceDistributorExclusive = response));
    this.getBrand();
    this.setTableData();
    this.handlePrivilege();
    this.queryHandler();
    this.initPageInfo();
  }

  getBrand() {
    this.BrandId.next(this.activeRoute.snapshot.params.id);
    this.getDataDetail();

    this.modalDetailConfig = {
      showFooter: false,
      showHeader: false,
    };

    this.modalDetailOption = {
      size: 'lg',
    };
  }

  initPageInfo() {
    this.pageInfoService.updateTitle('Detail Product');
    this.detailProduct.subscribe((data) => {
      this.links = [
        {
          title: 'Product Catalog',
          path: '',
          isActive: false,
        },
        {
          title: '',
          path: '',
          isActive: false,
          isSeparator: true,
        },
        {
          title: 'Product List',
          path: 'products/list-published',
          isActive: false,
        },
        {
          title: '',
          path: '',
          isActive: false,
          isSeparator: true,
        },
        {
          title: data?.name ?? '',
          path: 'products/detail/' + this.BrandId.value,
          isActive: false,
        },
        {
          title: '',
          path: '',
          isActive: false,
          isSeparator: true,
        },
        {
          title: 'Riwayat Distributor Eksklusif',
          path: '',
          isActive: true,
        },
      ];
      this.pageInfoService.updateBreadcrumbs(this.links);
    });

    const dataSubs = this.baseDatasourceDistributorExclusive.tableSubject.subscribe((resp) => (this.distributorExclusiveList = resp));
    this.unsubscribe.push(dataSubs);
    this.ref.detectChanges();
  }

  setTableData() {
    this.isLoading.next(false);
    this.tableColumns = [
      { title: 'DISTRIBUTOR', key: 'distributor_name' },
      { title: 'VARIAN', key: 'variants' },
      { title: 'CAKUPAN AREA', key: 'area_name' },
      { title: 'CAKUPAN SUB AREA', key: 'list_sub_area' },
      { title: 'DIUBAH OLEH', key: 'deleted_by' },
      { title: 'TANGGAL DIUBAH', key: 'deleted_time' },
      { title: 'ACTION', key: 'actions' },
    ];

    this.displayedColumns = this.tableColumns.map((head) => head.key);

    if (this.distributorExclusiveList) {
      this.baseDatasourceDistributorExclusive.tableSubject.next(this.distributorExclusiveList);
    }
  }

  setDetailProduct(data: IListHistoryDistributorExclusive) {
    const title: string = 'DETAIL DISTRIBUTOR EKSKLUSIF';
    const detail: IKeyValue[] = [
      { key: 'Reason', value: data.reasons },
      { key: 'Distributor', value: data.distributor_name },
      { key: 'Varian', value: data.variants?.length > 0 ? data.variants.join(', ').toString() : '-' },
      { key: 'Cakupan Area', value: data.area_name },
      { key: 'Cakupan Sub Area', value: this.mapSubAreaObject(data.list_sub_area) },
      { key: 'Dibuat Oleh', value: data.deleted_by },
      {
        key: 'Tanggal Dibuat',
        value: data.deleted_time ? this.utilities.timeStampToDate(data.deleted_time, 'dd-MM-yyyy HH:mm:ss') : '-',
      },
    ];
    const images = data.distributor_document ? data.distributor_document : [];
    this.detailDistributorExclusiveData.next({ title, detail, images });
  }

  queryHandler() {
    const paramSubs = this.activeRoute.queryParams.subscribe((data) => {
      this.string_filter = data.string_filter;
      const _queryParams = this.urlParamService.sliceQueryParams();
      this.loadDataTable(_queryParams ? _queryParams : '');
    });

    this.unsubscribe.push(paramSubs);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  loadDataTable(params: string) {
    return this.baseTableService.loadDataTable(API.GET_LIST_HISTORY_DISTRIBUTOR_EXCLUSIVE + this.BrandId.value, params);
  }

  handleAction(data: IListHistoryDistributorExclusive) {
    const mainData = data;
    if (mainData) {
      this.modalDetail.setUrlPreview = mainData.distributor_document ? mainData.distributor_document[0] : '';
      this.modalDetail.setImageList = mainData.distributor_document ? mainData.distributor_document : [];
      this.setDetailProduct(mainData);
      this.ref.detectChanges();
      return this.modalDetail.openModal();
    }
  }

  changePageEvent($event: any) {
    this.filterService.changePageEvent($event, this.string_filter ?? '');
  }

  handleSearch(e: string) {
    this.string_filter = e;
    if (this.string_filter) {
      const dataParam: IQueryParams = {
        string_filter: this.string_filter,
      };
      this.router
        .navigate([], {
          queryParams: {
            ...dataParam,
          },
        })
        .then();
    } else {
      const snapshot = this.activeRoute.snapshot;
      const params = { ...snapshot.queryParams };
      delete params.string_filter;
      this.router.navigate([], { queryParams: params }).then(() => null);
    }
  }

  handlePrivilege() {
    this.privilegeEditProduct = this.rolePrivilegeService.checkPrivilege(this.parentMenu, this.keyProductPrivilege, this.keyDetailPrivilege, 'CTA_EDIT');
    this.privilegeUnpublishedProduct = this.rolePrivilegeService.checkPrivilege(this.parentMenu, this.keyProductPrivilege, this.keyDetailPrivilege, 'CTA_UNPUBLISH');
  }

  getDataDetail() {
    this.baseService.getData<IDetailProduct>(API.GET_DETAIL_BRAND + this.BrandId.value).subscribe((res) => {
      if (res) {
        this.detailProduct.next(res.data);
      }
    });
  }

  async onClickEditProduct() {
    return this.router.navigate(['/products/detail/edit/' + this.productId]).then();
  }

  async handleBack() {
    return this.router.navigate(['/products/detail/' + this.BrandId.value]).then();
  }

  setVariantItem(item: string[]) {
    if (item?.length) {
      const data = item[0];
      return {
        count: item.length - 1,
        name: data,
      };
    }
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  mapSubAreaObject(item: string[]) {
    const result = item?.length ? item.join(', ') : 'SEMUA';
    return this.utilities.toCapitalize(result);
  }
}
